var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoged)?_c('div',{staticClass:"footer noprint mt-3"},[_c('div',{staticClass:"container-new-footer"},[_c('span',[_vm._v(" Copyright © KEY LEARNING SpA "+_vm._s(_vm.currentYear)+". Todos los derechos reservados. ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }